// decodeJwtActorEmail extracts the actor_email claim from a JWT payload, or
// returns undefined if the token is malformed or the claim is missing. Only
// trusted when combined with a successful server-side session validation —
// the client never signs, so this is purely for rendering the "impersonating"
// banner and not for any authorization decision.
export const decodeJwtActorEmail = (token: string): string | undefined => {
  const parts = token.split('.')
  if (parts.length !== 3) return undefined
  try {
    const payload = parts[1].replace(/-/g, '+').replace(/_/g, '/')
    const padded = payload + '='.repeat((4 - payload.length % 4) % 4)
    const claims = JSON.parse(atob(padded))
    return typeof claims.actor_email === 'string' && claims.actor_email.length > 0
      ? claims.actor_email
      : undefined
  } catch {
    return undefined
  }
}

// deriveIsImpersonating decides whether the UI should render the "you are
// impersonating X" banner. Compares actorEmail to the effective session email
// case-insensitively so "manager@X.com" impersonating "Manager@X.com" would
// *not* trigger the banner (same identity, differently cased).
export const deriveIsImpersonating = (
  actorEmail: string | undefined,
  effectiveEmail: string | undefined,
): boolean => {
  if (!actorEmail || !effectiveEmail) return false
  return actorEmail.toLowerCase() !== effectiveEmail.toLowerCase()
}
